<script lang="ts">
    import { _ } from 'svelte-i18n';
    import Select from '../../shared/Select.svelte';
    import { permissionStateOf, permissionStates, type PanelUserType, type PermissionStateId } from './UserPermissionsApi';
    import { debug } from '../../../stores/store';

    export let user: PanelUserType;
    /** Zapis stanu; false oznacza odmowę - kontrolka wraca wtedy do wartości sprzed zmiany. */
    export let onChange: (user: PanelUserType, state: PermissionStateId) => Promise<boolean>;

    let saving: boolean = false;

    /**
     * Wiersz jest jedynym właścicielem wartości kontrolki i przekazuje ją jednokierunkowo - wzorzec
     * z SettingsLocales i JobEditForm. Wcześniejsze `bind:selected` obok tego wyliczenia i ręcznego
     * revertu dawało trzech pisarzy jednej zmiennej.
     *
     * Przypisanie reaktywne przelicza stan, gdy lista podmieni obiekt wiersza po udanym zapisie;
     * zmiana wybrana przez użytkownika nie rusza `user`, więc go nie nadpisuje.
     */
    let selected: PermissionStateId = permissionStateOf(user);
    $: selected = permissionStateOf(user);

    async function save(state: PermissionStateId): Promise<void> {
        // Kontrolka jest w tym czasie `disabled` (AC 5), ale `saving` przestawia się dopiero w flushu po
        // obsłudze `change`, więc drugie zdarzenie zdąży wejść przed przerysowaniem - stąd ten guard.
        if (saving) {
            return;
        }

        const previous = permissionStateOf(user);
        saving = true;
        const success = await onChange(user, state);
        saving = false;

        if (!success) {
            selected = previous;
        }
    }

    /**
     * Select oczekuje synchronicznej odpowiedzi, a zapis jest asynchroniczny - zwracamy true i sami
     * cofamy kontrolkę przy odmowie. Zwrócenie false wyzerowałoby wartość, a AC wymaga powrotu do
     * stanu sprzed zmiany.
     *
     * Ustawienie `selected` z góry jest konieczne: przy odmowie `save()` wraca do `previous`, a gdyby
     * prop nie zmienił się w tę i z powrotem, Svelte nie zobaczyłby różnicy i kontrolka zostałaby na
     * wartości odrzuconej przez backend.
     */
    function handleSelect(value: string): boolean {
        selected = value as PermissionStateId;
        void save(selected);

        return true;
    }
</script>

<div class="row" class:blocked={!user.can_read}>
    <div class="cell comment" title={user.comment ?? ''}>
        {#if $debug}
            [#{user.webuser_id}]
        {/if}
        {user.comment ?? '-'}
    </div>
    <div class="cell role">{user.is_user_manager ? $_('User manager') : $_('User standard')}</div>
    <div class="cell state" style="flex-direction: row;
  display: flex;
  align-items: center;
  column-gap: 7px;">
        <Select
            items={permissionStates}
            {selected}
            withBorder={true}
            disabled={!user.editable || saving}
            onChange={handleSelect}
        />
        <div>
            {#if !user.editable}
                <div style="
  font-size: 19px;
  font-weight: 600;
  /*background-color: cadetblue;*/
  width: 14px;
  border-radius: 50%;
  padding: 4px;
  line-height: 10px;
  cursor: pointer;
  height: 14px;
  color: black;
" title="Blokada edycji uprawnień własnego konta. Skontaktuj się z działem handlowym, aby zmienić swoje uprawnienia.">*</div>
            {/if}
        </div>
    </div>
</div>

<style>
    .row {
        display: grid;
        grid-template-columns: minmax(200px, 1fr) 140px 220px;
        align-items: center;
        column-gap: 10px;
        padding: 2px 10px;
        border-bottom: 1px solid #f2f2f2;
    }
    .row.blocked {
        /*background-color: #fdf6f6;*/
    }
    .cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .id {
        color: #777;
    }
    .role {
        color: #777;
    }
</style>
